import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";

const useKlydoUpdateLabelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      labelId,
      text,
    }: {
      labelId: string;
      text: string;
    }) => {
      return await klydoApiClient.updateKlydoLabel(labelId, text);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydo-labels"] });
    },
    onError: (error) => {
      console.error("Failed to update klydo label:", error);
    },
  });
};

export default useKlydoUpdateLabelMutation;
